export const ZOOM_CONFIG = {
  min: 0.05,
  max: 15,
  factor: 1.15,
} as const;

export const LAYOUT_CONFIG = {
  svgWidth: 1200,
  svgHeight: 600,

  baseNodeHeight: 150,
  nodeWidth: 8,

  sourceNodesX: 350,
  rightMargin: 200,

  spacing: {
    low: 48,
    medium: 32,
    high: 48,
  },

  heightMultipliers: {
    veryHigh: 0.5,
    high: 0.6,
    medium: 0.8,
    low: 0.7,
  },

  minHeights: {
    veryHigh: 1,
    high: 2,
    medium: 4,
    low: 8,
  },

  thresholds: {
    veryHigh: 30,
    high: 20,
    medium: 15,
    low: 10,
    maxLabels: 60,
  },

  labelCard: {
    minWidth: 170,
    leftPaddingLarge: 38,
    leftPaddingSmall: 12,
    rightPadding: 12,
    offsetX: 10,
    heightLarge: 44,
    heightSmall: 40,
    charWidthLarge: 5.5,
    charWidthSmall: 4.7,
    truncationLarge: 35,
    truncationSmall: 45,
  },

  topOffset: 80,

  tooltipOffset: 16,
} as const;
